<template>
    <div class="kefu"> 
      <div class="flex_ul desc">
             <!-- <router-link :class="{'active':$route.path=='/'}" to="/">
                <img class="zhibo" src="../assets/but_pic_zhibo.png" alt=""><span>直播课堂</span>
             </router-link> -->
             <a href="javascript:void(0);" @click="imgState = !imgState" class="wx">
              <img src="../assets/but_pic_zhibo.png" alt=""><span>直播课堂</span>
            </a>
            <a href="https://work.weixin.qq.com/kfid/kfc0ae849ff0e387937"><img class="zhibo" src="../assets/but_pic_wx.png" alt=""><span>微信咨询</span></a>

            <a href="tel:13632764231" class="phone"><img src="../assets/but_pic_telt.png" alt=""><span>电话咨询</span></a>
      </div>  
      <div class="kefuImg" :class="{'show':imgState,'unshow':!imgState}" @click="imgState=!imgState">
         <div class="bg">
            <img class="code" src="../assets/1566504801a7afbf1536eed8a789b78.jpg" alt="">
            <div class="desc">扫码/识别，关注易小淘直播课堂</div>
         </div>
      </div> 
    </div>
</template>
<script>
export default {
    data() {
      return {
        imgState: false,
        data:''
      }
    },
      mounted () {
    this.data=this.getRandom(10,20)
  },
  methods:{
     getRandom(min,max){
      return Math.floor(Math.random()*(max-min+1)+min)
    }
  }
}
</script>
<style scoped lang='less'>
.kefu{
        width: 100%;
        z-index: 999;
        position: fixed;
        bottom: 0;
        .wx{
          img{
            width: .38rem;
            height: .38rem;
          }
        }
  
  .flex_ul{
    height: .8rem;
     display: flex;
     align-items: center;
     justify-content: center;
      a{
        display: flex;
        align-items: center;
        justify-content: center;
        display: inline-block;
        text-align: center;
        width: 33.3%;
        height: 100%;
        background: #EC6A3D;
        line-height: 0.8rem;
        img{
          width: .36rem;
          height: .36rem;
          display:inline-block;
          vertical-align: middle;
          margin-right: 0.1rem;
        }
        span{
           font-size: .26rem;
           color:#FFFFFF;;
           display: inline-block;
        }
        .zhibo{
          width: .34rem;
          height: .34rem;
        }
    }
  }
  .kefur{
     position: relative;
        .num{
            width: .5rem;
            height: .5rem;
            font-size: .3rem;
            line-height: .5rem;
            border-radius: .5rem;
            background-color: #a50909;
            color: #F1F1F1;
            position: absolute;
            top: -.3rem;
            right: .2rem;
            
        }
 }
 .show{
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      margin: auto;
      z-index: 9999;
      text-align: center;
      .bg{
         width: 5rem;
         height: 6rem; 
         background: #fff;
         margin:4rem auto;
         img{
          margin-bottom: 0;
          width: 4.5rem;
          height: 5rem;
        
        }
        .desc{
          font-size: .24rem;
          color: #333;
        }
      }
      
      
    }
    .unshow{
      display:none;
    }
}
    
</style>



// WEBPACK FOOTER //
// src/components/footer.vue